import ENDPOINT from "@/api/endpoints";
import {
  callApiLayDanhSachTatCaQuyen,
  callApiLayDanhSachQuyenTheoAppPaging,
  callApiLayDanhSachTatCaQuyenTheoApp,
  callApiLayDanhSachQuyenKhongThuocVaiTro,
  callApiLayDanhSachQuyenTheoVaiTro,
  callApiLayDanhSachQuyenKhongThuocGroup,
  callApiAddOrUpdateObjectPermisions,
  callApiRemoveItemObjectPermission,
  callApiActivePermission,
  callApiXoaPhamViQuyen,
  callApiConfigPhamViQuyen,
  callApiXoaActorMapping
} from "@/api/permission";
import { showMsgError } from "@/utils/commonUtils";
const layDanhSachQuyenTheoNguoiDung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachTatCaQuyen(
      payload,
      ENDPOINT.PERMISSION.DANH_SACH_TAT_CA_QUYEN
    )
      .then(response => {
        if (response) {
          context.commit("SET_DANH_SACH_TAT_CA_QUYEN", response.data.data);
        }
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const layDanhSachQuyenTheoAppPaging = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachQuyenTheoAppPaging(payload)
      .then(response => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_QUYEN_TRONG_APP_PAGING",
            response.data.data
          );
        }
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const layDanhSachTatCaQuyenTheoApp = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachTatCaQuyenTheoApp(payload)
      .then(response => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_TAT_CA_QUYEN_TRONG_APP",
            response.data.data
          );
        }
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const layDanhSachQuyenKhongThuocVaiTro = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachQuyenKhongThuocVaiTro(payload)
      .then(response => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_QUYEN_KHONG_THUOC_VAI_TRO",
            response.data.data
          );
        }
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const layDanhSachQuyenTheoVaiTro = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachQuyenTheoVaiTro(payload)
      .then(response => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_QUYEN_THEO_VAI_TRO",
            response.data.data
          );
        }
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const layDanhSachQuyenKhongThuocGroup = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachQuyenKhongThuocGroup(payload)
      .then(response => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_QUYEN_KHONG_THUOC_GROUP",
            response.data.data
          );
        }
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const addOrUpdateObjectPermisions = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiAddOrUpdateObjectPermisions(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const removeItemObjectPermission = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiRemoveItemObjectPermission(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const activePermission = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiActivePermission(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const xoaPhamViQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaPhamViQuyen(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const configPhamViQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiConfigPhamViQuyen(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const xoaActorMapping = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaActorMapping(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

export default {
  layDanhSachQuyenTheoNguoiDung,
  layDanhSachQuyenTheoAppPaging,
  layDanhSachTatCaQuyenTheoApp,
  layDanhSachQuyenKhongThuocVaiTro,
  layDanhSachQuyenTheoVaiTro,
  layDanhSachQuyenKhongThuocGroup,
  addOrUpdateObjectPermisions,
  removeItemObjectPermission,
  activePermission,
  xoaPhamViQuyen,
  configPhamViQuyen,
  xoaActorMapping
};
